import { render } from "./BartenderView.vue?vue&type=template&id=4253c547&scoped=true"
import script from "./BartenderView.vue?vue&type=script&lang=js"
export * from "./BartenderView.vue?vue&type=script&lang=js"

import "./BartenderView.vue?vue&type=style&index=0&id=4253c547&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4253c547"]])

export default __exports__